export default "__VITE_ASSET__CXLg0e0O__"